
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { JobActions } from "@/components/jobs/components/JobActions";
import { Job } from "@/types/job"; // Using global Job type

interface JobsListProps {
  jobs: Job[]; // Use the global Job type
}

const getStatusBadge = (status: string) => {
  switch (status.toLowerCase()) {
    case "open":
      return <Badge className="bg-green-500 hover:bg-green-600 text-white">Open</Badge>;
    case "filled":
      return <Badge className="bg-blue-500 hover:bg-blue-600 text-white">Filled</Badge>;
    case "on hold":
    case "on-hold":
      return <Badge variant="outline">On Hold</Badge>;
    default:
      return <Badge variant="secondary">{status}</Badge>;
  }
};

const JobsList: React.FC<JobsListProps> = ({ jobs }) => {
  if (jobs.length === 0) {
    return (
      <Card>
        <CardContent className="py-10 text-center text-muted-foreground">
          No jobs found.
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      {jobs.map((job) => (
        <Card key={job.id}>
          <CardHeader className="py-4 px-6 flex flex-row items-center justify-between">
            <div>
              <CardTitle className="text-base font-medium">
                {job.title}
              </CardTitle>
              <div className="flex items-center gap-2 mt-1">
                {getStatusBadge(job.status || 'N/A')} {/* Added fallback for status */}
                <span className="text-sm text-muted-foreground">
                  {job.candidates || 0} candidates {/* Fallback for candidates */}
                </span>
                <span className="text-sm text-muted-foreground">
                  Posted: {job.posted ? new Date(job.posted).toLocaleDateString() : 'N/A'} {/* Use job.posted */}
                </span>
              </div>
            </div>
            <JobActions jobId={job.id} />
          </CardHeader>
        </Card>
      ))}
    </div>
  );
};

export default JobsList;
